import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 11.5l4.5 4.5h9l-9 -9l-4.5 4.5","key":"svg-0"}],["path",{"d":"M16.5 16l4.5 -4.5l-4.5 -4.5l-4.5 4.5","key":"svg-1"}]]

const IconBrandAlpineJs = createReactComponent('outline', 'brand-alpine-js', 'BrandAlpineJs', __iconNode);

export default IconBrandAlpineJs;